export const REPORTS_NAMESPACE_TRANSLATIONS = {
  generateReport: {
    title: "Générer des Rapports",
    description:
      "Générez des rapports sur les animaux de la ferme avec des informations liées à la race, l'espèce, le sexe et leurs données pertinentes.",
    note: "Les rapports seront disponibles dans la section Rapports après génération, cela peut prendre jusqu'à 15 secondes.",
    pending: "Génération du rapport...",
    success: "Rapport généré avec succès !",
    error: "Erreur lors de la génération du rapport. Veuillez réessayer.",
    button: "Générer le Rapport d'Animaux",
    buttonGenerating: "Génération...",
  },

  individualAnimalReports: {
    title: "Rapports Individuels d'Animaux",
    description:
      "Générez des rapports détaillés sur un animal, reproduction, santé et productivité.",
    note: "Les rapports seront disponibles ci-dessous après génération, cela peut prendre jusqu'à 15 secondes.",
    button: "Générer rapport d'animal",
  },

  filters: {
    all: "Tous les Rapports",
    animal: "Rapports d'Animaux",
    financial: "Rapports Financiers",
    production: "Rapports de Production",
  },

  status: {
    pending: "En attente",
    processing: "Traitement",
    completed: "Terminé",
    failed: "Échoué",
  },
}
